import api from '@/logic/api'
import { relaunchApi } from '@/logic/relaunchApi'

export default {
  getAppointments: () => relaunchApi.get('/appointments'),
  register: (appointmentId) => api.post(`/appointments/${appointmentId}/register`),
  unregister: (appointmentId) => api.post(`/appointments/${appointmentId}/unregister`),
}
